<section class="container-fluid">
    <header class="row pt-3">
        <div class="col-12 d-flex justify-content-between">
            <div>
                <h4 class="text-white">Crear frente</h4>
            </div>
            <div>
                <div>
                            <button
                            class="badge rounded-pill btn btn-outline-light mx-2"
                            [routerLink]="['/pdg/client/frente/',id]"
                          >
                            <i
                              class="fa-solid fa-right-from-bracket m-2 fs-6"
                              aria-hidden="true"
                            ></i>
                            <span class="m-2 fs-6">Volver al listado</span>
                          </button>
                </div>
            </div>
        </div>
    </header>

</section>
<section class="container-fluid shadow pt-3 pb-2 text-white backgroundTable mt-3 " style="min-height:750px !important;">
    <div class="container-fluid d-flex justify-content-between align-items-center">
        <div>
            <h5 class="ms-3">Ingrese los datos</h5>
        </div>
    </div>

    <!-- Datos -->
    <div class="componente-importantes text-start px-5 mt-3" style="min-height:750px ;">
        <form action="" method="post" (submit)="formSubmit()" [formGroup]="createClientForm">
        <section class="row  ">
            <div class="col-12  justify-content-lg-start">
                <div>
                    <label for="formControlInput" class="form-label mt-5"><b>Nombre frente</b></label>
                    <input placeholder="Ingrese frente" type="text" formControlName="name" class="form-control custom-outline-input date" >
                </div>
            </div>
               
          

        </section>
    

        <footer class="row mt-5 pb-3">
            <div class="col-12 d-flex justify-content-end">
                <button class="mx-2 btn btn-outline-light"> <i class="fa fa-floppy-disk" aria-hidden="true"></i> Guardar
                    datos</button>
            </div>
        </footer>
    </form>
    </div>


</section>